<template>
    <div class="container">
        <h1 class="container__title h1">
            <template v-if="newLink"
                >New {{ this.socialLink ? 'social' : '' }} link</template
            >
            <template v-else>Edit link</template>
        </h1>

        <el-form ref="form" :model="formData" :rules="validationRules">
            <el-form-item
                v-if="mergedTree.type === 'gallery' && config === 'link'"
                label="Link image"
                class="space-bottom--medium"
                prop="image"
            >
                <el-input
                    ref="linkimage"
                    @change="handleLinkFileUpload()"
                    accept="image/png, image/jpeg, image/jpg"
                    type="file"
                    v-model="image"
                ></el-input>
            </el-form-item>

            <el-form-item
                v-if="mergedTree.type === 'gallery' && config === 'link'"
                class="space-bottom--medium"
                label="Link Icon"
            >
                <el-select v-model="formData.icon_type">
                    <el-option
                        v-for="link in linkIconOptions"
                        :key="link.value"
                        :label="link.label"
                        :value="link.value"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item
                label="Link name"
                class="space-bottom--medium"
                prop="short_name"
            >
                <el-input
                    v-model="formData.short_name"
                    @input="touchForm"
                ></el-input>
            </el-form-item>
            <!-- <el-form-item
                label="Link text"
                class="space-bottom--medium"
                prop="text"
            >
                <el-input v-model="formData.text" @input="touchForm"></el-input>
            </el-form-item> -->
            <el-form-item
                label="Link URL"
                class="space-bottom--medium"
                prop="url"
            >
                <el-input v-model="formData.url" @input="touchForm"></el-input>
            </el-form-item>
            <el-form-item
                class="space-bottom--medium"
                v-if="!socialLink && !footerLink"
            >
                <el-radio
                    v-model="formData.highlightString"
                    label="false"
                    @change="touchForm"
                    >Standard link</el-radio
                >
                <el-radio
                    v-model="formData.highlightString"
                    label="true"
                    @change="touchForm"
                    >Highlight link</el-radio
                >
            </el-form-item>
            <el-form-item
                v-if="socialLink"
                class="space-bottom--medium"
                label="Social icon"
            >
                <el-select v-model="formData.type">
                    <el-option
                        v-for="link in socialLinkOptions"
                        :key="link.value"
                        :label="link.label"
                        :value="link.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="Custom Icon Upload (SVG)"
                class="space-bottom--medium"
                v-if="socialLink && formData.type == 'social-custom'"
            >
                <el-input
                    ref="customicon"
                    @change="handleFileUpload()"
                    accept="image/svg+xml"
                    type="file"
                    v-model="helpfile"
                    @input="touchForm"
                ></el-input>
            </el-form-item>
            <el-form-item class="space-top">
                <Button size="big" @click="submitForm" :showLoader="isLoading"
                    >Save</Button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/Button.vue';
import * as api from '@/api';

export default {
    components: {
        Button,
    },
    props: {
        newLink: {
            type: Boolean,
            default: false,
        },
        config: {
            type: String,
            default: '',
        },
        slug: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            image: '',
            socialLink:
                this.$route.query.social || this.config == 'social'
                    ? true
                    : false,
            footerLink:
                this.$route.query.footer || this.config == 'footer'
                    ? true
                    : false,
            formTouched: false,
            isLoading: false,
            formData: {
                active: true,
                short_name: '',
                text: '',
                url: '',
                highlight: false,
                highlightString: 'false',
                type: 'link',
                position: 0,
                slug: false,
                image: '',
                image_hash_id: false,
            },
            helpfile: '',
            validationRules: {
                short_name: [
                    {
                        required: true,
                        message: 'Please enter a name',
                        trigger: 'blur',
                    },
                ],
                // text: [
                //     {
                //         required: true,
                //         message: 'Please enter a text',
                //         trigger: 'blur',
                //     },
                // ],
                url: [
                    {
                        required: true,
                        message: 'Please enter an URL',
                        trigger: 'blur',
                        type: 'url',
                    },
                ],
            },
            socialLinkOptions: [
                {
                    value: 'social-instagram',
                    label: 'Instagram',
                },
                {
                    value: 'social-facebook',
                    label: 'Facebook',
                },
                {
                    value: 'social-linkedin',
                    label: 'LinkedIn',
                },
                {
                    value: 'social-youtube',
                    label: 'Youtube',
                },
                {
                    value: 'social-pinterest',
                    label: 'Pinterest',
                },
                {
                    value: 'social-twitter',
                    label: 'Twitter',
                },
                {
                    value: 'social-tiktok',
                    label: 'TikTok',
                },
                {
                    value: 'social-web',
                    label: 'Web',
                },
                {
                    value: 'social-custom',
                    label: 'Custom',
                },
            ],
            linkIconOptions: [
                {
                    value: '',
                    label: 'None',
                },
                {
                    value: 'reel',
                    label: 'Reel',
                },
                {
                    value: 'gallery',
                    label: 'Gallery',
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['activeTree', 'manipulatedData', 'organisation']),
        mergedTree() {
            return { ...this.activeTree, ...this.manipulatedData };
        },
    },
    watch: {
        activeTree() {
            this.formData.position = this.activeTree.links
                ? this.activeTree.links.data.length
                : 0;
        },
        formData: {
            deep: true,
            handler() {
                this.formData.highlight =
                    this.formData.highlightString === 'true' ? true : false;

                if (!this.activeTree) return;
                const linksTemp = this.activeTree.links
                    ? this.activeTree.links.data.slice()
                    : [];
                if (this.newLink) {
                    linksTemp.push(this.formData);
                } else {
                    const index = this.activeTree.links.data.findIndex(
                        l => l.slug === this.slug,
                    );
                    linksTemp[index] = this.formData;
                }
                if (this.formData.short_name) {
                    this.$store.commit('setManipulatedData', {
                        links: {
                            data: linksTemp,
                        },
                    });
                }
            },
        },
        slug() {
            if (this.slug != '##PLACEHOLDER##') this.init_form();
        },
    },
    mounted() {
        this.init_form();

        if (this.newLink) {
            var temp_tree = new Array();
            var temp_pos = 0;

            if (typeof this.activeTree.links !== 'undefined') {
                this.activeTree.links.data.forEach(l => {
                    if (
                        (this.config == 'link' && l.type == 'link') ||
                        (this.config.indexOf('social') >= 0 &&
                            l.type.indexOf('social') >= 0) ||
                        (this.config == 'footer' && l.type == 'footer')
                    ) {
                        temp_tree.push(l);
                        if (l.position > temp_pos) temp_pos = l.position;
                    }
                });
            }

            this.formData.position = temp_pos + 1;
        }
    },
    methods: {
        init_form() {
            if (!this.newLink) {
                this.loadData();
            }
            if (this.socialLink) {
                this.formData.type = 'social-web';
            }
            if (this.footerLink) {
                this.formData.type = 'footer';
            }
        },

        async loadData() {
            try {
                const response = await api.link.get(this.slug);
                this.formData = { ...this.formData, ...response.data.data };

                this.formData.highlight = response.data.data.highlight;
                this.formData.highlightString = this.formData.highlight
                    ? 'true'
                    : 'false';

                if (this.formData.shot_name) {
                    this.formData.short_name = this.formData.shot_name;
                } else if (this.formData.short_name) {
                    this.formData.short_name = this.$func.decodeHTMLEntities(
                        this.formData.short_name,
                    );
                }
                if (this.formData.type.includes('social-')) {
                    this.socialLink = true;
                }
                if (this.formData.type === 'footer') {
                    this.footerLink = true;
                }
            } catch (error) {
                console.error(error);
            }
        },
        async sendForm() {
            try {
                let response;
                this.formData.text = this.formData.short_name;

                var send_data = new FormData();
                for (var key in this.formData) {
                    if (
                        (this.formData['type'] != 'social-custom' &&
                            key == 'image') ||
                        key == 'updated_values' ||
                        (key == 'image' && this.formData[key] == '')
                    ) {
                        // do nothing
                    } else if (
                        (key === 'image_hash_id' &&
                            this.formData[key] === false) ||
                        key === 'gallery_image'
                    ) {
                        // do nothing
                    } else if (
                        key === 'icon_type' &&
                        this.formData[key] === null
                    ) {
                        // do nothing
                    } else {
                        send_data.append(key, this.formData[key]);
                    }
                }

                if (
                    !(
                        this.mergedTree.type === 'gallery' &&
                        this.config === 'link'
                    ) ||
                    send_data.get('icon_type') === null ||
                    send_data.get('icon_type') === ''
                ) {
                    send_data.delete('icon_type');
                }

                if (this.newLink) {
                    response = await api.link.create(
                        this.organisation.slug,
                        this.activeTree.slug,
                        send_data,
                    );
                } else {
                    response = await api.link.update(this.slug, send_data);
                }
                if (response) {
                    this.$message({
                        message: 'Link successfully saved!',
                        type: 'success',
                    });

                    this.$store.dispatch('clearManipulatedData');

                    this.$store.dispatch('loadTree', {
                        slug: this.$route.params.treeslug,
                    });

                    this.isLoading = false;
                    this.$emit('close');
                }
            } catch (error) {
                this.isLoading = false;
                this.$message({
                    message: 'Something went wrong.',
                    type: 'error',
                });
            }
        },
        touchForm() {
            this.formTouched = true;
        },
        submitForm() {
            this.isLoading = true;
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.sendForm();
                    this.formTouched = false;
                } else {
                    this.isLoading = false;
                    return false;
                }
            });
        },
        handleFileUpload() {
            this.formData.image = this.$refs.customicon.$refs.input.files[0];
        },
        async handleLinkFileUpload() {
            try {
                this.$store.commit('setDim', true);

                var send_data = new FormData();
                send_data.append(
                    'image',
                    this.$refs.linkimage.$refs.input.files[0],
                    this.$refs.linkimage.$refs.input.files[0].name,
                );
                var response = await api.link.uploadImage(send_data);
                this.formData.image_hash_id = response.data.data.id;

                this.$store.commit('setDim', false);
            } catch (error) {
                this.$store.commit('setDim', false);
                this.isLoading = false;
                this.$message({
                    message: 'Something went wrong.',
                    type: 'error',
                });
            }
        },
    },
};
</script>
